export default __webpack_public_path__ + "static/media/mobile1.520cdd6a.png";